import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { StickyNote } from "lucide-react";

export function PendingNotesModal() {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    api.get("/notes/pending").then((r) => setNotes(r.data)).catch(() => {});
  }, []);

  const note = notes[0];
  const ack = async () => {
    await api.post(`/notes/${note.id}/ack`).catch(() => {});
    setNotes((n) => n.slice(1));
  };

  return (
    <Dialog open={!!note} onOpenChange={() => {}}>
      <DialogContent className="rounded-none border-2 border-black max-w-md [&>button]:hidden" data-testid="pending-note-modal">
        {note && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display flex items-center gap-2">
                <StickyNote size={18} className="text-[#F5B301]" /> Tienes una nota
              </DialogTitle>
              <DialogDescription data-testid="pending-note-sender">
                <b>{note.sender_name}</b> te ha dejado una nota que dice lo siguiente:
              </DialogDescription>
            </DialogHeader>
            <p className="bg-[#FFF8E1] border-l-4 border-[#F5B301] p-4 text-sm whitespace-pre-wrap" data-testid="pending-note-text">
              {note.text}
            </p>
            <div className="flex items-center justify-between gap-3">
              <span className="text-[11px] text-zinc-500">
                {new Date(note.created_at).toLocaleString("es-ES")}
                {notes.length > 1 ? ` · ${notes.length - 1} más` : ""}
              </span>
              <button onClick={ack} data-testid="pending-note-ack" className="h-10 px-6 bg-black text-white text-xs font-semibold uppercase tracking-widest hover:bg-[#E63946] transition-colors">
                Entendido
              </button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
